<script>
  /**
   * @type{boolean}
  */
  export let showDiscountFields;
  /**
   * @type{any}
   */
  export let normalDeliveryNoDiscounts;

  /**
   * @type{number}
  */
  export let deliveryDiscountPercentage;
  /**
   * @type{import('svelte/store').Writable<import('./proto/products_pb').ShoppingCartProduct[]>}
   */
  export let items;
  /** @type{number} */
  export let deliveryCost;
  /** @type{number} */
  export let totalDeliveryCost;
</script>
<style>
    td {
        padding: 0.5rem;
        vertical-align: center;
    }
</style>
<section class="sticky top-40 h-[30%]">
    <div class="">
        <span class="text-xl font-bold mb-5 block text-center">Преглед на поръчката</span>
        <table class="border border-black border-none table-fixed">
            <tr>
                <th>Продукт</th>
                <th>Количество</th>
                <th>Общо</th>
            </tr>
            {#each $items as item, index (index)}
                <tr>
                    <td>{item.getProduct().getName()}</td>
                    <td class="text-center">{item.getQuantity()}</td>
                    <td class="text-right">{(item.getProduct()?.getDiscountedprice() * item.getQuantity()).toFixed(2)}лв</td>
                </tr>
            {/each}
            {#if showDiscountFields}
                <tr class="border-gray-300">
                    <td>Доставка</td>
                    <td></td>
                    <td class="text-right">{normalDeliveryNoDiscounts.toFixed(2)}лв</td>
                </tr>
                {#if deliveryDiscountPercentage > 0}
                <tr class="border-b border-gray-300">
                    <td>Отстъпка доставка</td>
                    <td></td>
                    <td class="text-right">-{(deliveryDiscountPercentage * normalDeliveryNoDiscounts).toFixed(2)}лв</td>
                </tr>
                {/if}
            {/if}
            <tr>
                <td>Обща сума</td>
                <td></td>
                <td class="text-right w-[100px]">{totalDeliveryCost.toFixed(2)}лв</td>
            </tr>
        </table>
    </div>
</section>

